import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Divider,
  Typography,
  useTheme,
} from '@mui/material'

import RawMessageBlock from '~/features/campaigns/components/promptMessageBlock'
import rem from '~/utils/ui'

export default function OFUSimulatePromptDetails({
  prompt,
  systemPrompt = '',
  evaluationPrompt = '',
  evaluationSystemPrompt = '',
}: {
  prompt: string
  systemPrompt?: string
  evaluationPrompt?: string
  evaluationSystemPrompt?: string
}) {
  const theme = useTheme()
  return (
    <Accordion
      elevation={0}
      sx={{
        background: 'transparent',
        '&.MuiAccordion-root::before': { display: 'none' },
      }}
      defaultExpanded={false}
    >
      <AccordionSummary
        sx={{
          p: 0,
          m: 0,
          px: 1,
          ml: rem(56),
          borderRadius: rem(10),
          mt: 1,
          backgroundColor: alpha(theme.palette.primary.main, 0.05),
          ':hover': { background: alpha(theme.palette.primary.main, 0.1) },
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography variant="body2">Show generation prompt</Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          p: 2,
          m: 0,
          ml: rem(56),
          borderRadius: rem(10),
          mt: 1,
          background: alpha(theme.palette.success.main, 0.1),
        }}
      >
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            Generation prompt
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This is the exact prompt the AI received to write this outreach. It
            comes in two parts: the standing instructions it always follows, and
            the specific details for this outreach. (Technically these are sent
            as a system message and a user message.)
          </Typography>
          {systemPrompt ? (
            <RawMessageBlock
              label="Instructions & rules"
              content={systemPrompt}
            />
          ) : null}
          <RawMessageBlock label="Details for this outreach" content={prompt} />

          {evaluationPrompt ? (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                Evaluation prompt
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This is the prompt the AI received to evaluate the outreach
                (outcome, follow-up, and contact status).
              </Typography>
              {evaluationSystemPrompt ? (
                <RawMessageBlock
                  label="Instructions & rules"
                  content={evaluationSystemPrompt}
                />
              ) : null}
              <RawMessageBlock
                label="Details for this evaluation"
                content={evaluationPrompt}
              />
            </>
          ) : null}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
